module.exports = __webpack_public_path__ + "static/media/ic_supply_apply.968410ed.png";